import LottiePlayer, { LottieRef } from 'lottie-react';
import { FC, useEffect, useRef } from 'react';

type TAnimationProps = {
  className?: string;
  animationData: unknown;
  isPaused: boolean;
};

const Animation: FC<TAnimationProps> = ({ className, animationData, isPaused }) => {
  const lottieRef = useRef<LottieRef['current'] | null>(null);

  useEffect(() => {
    if (isPaused) {
      lottieRef.current?.pause();
    } else {
      lottieRef.current?.play();
    }
  }, [isPaused]);

  return <LottiePlayer className={className} animationData={animationData} autoplay loop lottieRef={lottieRef} />;
};

export default Animation;
